import { render, staticRenderFns } from "./CheckResult.vue?vue&type=template&id=5257ff8a&scoped=true"
import script from "./CheckResult.vue?vue&type=script&lang=js"
export * from "./CheckResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257ff8a",
  null
  
)

export default component.exports